import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Paper,
  Typography,
  TextField,
  MenuItem,
  Button,
  CircularProgress,
  Alert,
} from '@mui/material';
import { useParams, useLocation } from 'react-router-dom';
import baseURL from '../../config';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RenewSubscription = () => {
  const { id } = useParams(); // vesselOwnerId
  const location = useLocation();
  const subscriptionId = location.state?.subscriptionId;
const fetchVesselCount = location.state?.vesselcount;
  

  const [email, setEmail] = useState('');
  const [vesselCount, setVesselCount] = useState(fetchVesselCount || 1);
  const [billingCycle, setBillingCycle] = useState('monthly');

  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  // Fetch vessel owner email
  useEffect(() => {
    const fetchVesselOwnerDetails = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${baseURL}/api/vesselDetails/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = response.data.data;
        if (data?.email) setEmail(data.email);
      } catch (err) {
        setErrorMsg('Failed to fetch vessel owner details.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchVesselOwnerDetails();
  }, [id]);

  const calculateRenewalAmount = (count, cycle) => {
    // 💡 Sample pricing logic (replace with your own pricing system)
    const baseRate = cycle === 'monthly' ? 1000 : 10000; // cents or rupees
    return count * baseRate;
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setSubmitting(true);

  try {
    const token = localStorage.getItem('token');
    const amount = calculateRenewalAmount(vesselCount, billingCycle);

    const response = await axios.post(
      `${baseURL}/api/vesselowner-subscription/addRenewal`,
      {
        subscriptionId,
        email,
        amount,
        currency: 'USD',
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const checkoutUrl = response.data?.url;
    if (checkoutUrl) {
      // ✅ Redirect to Stripe Checkout
      window.location.href = checkoutUrl;
    } else {
      toast.error('No checkout URL returned.');
    }
  } catch (err) {
    console.error('Renewal error:', err);
    toast.error(err.response?.data?.message || 'Failed to renew subscription');
  } finally {
    setSubmitting(false);
  }
};

  return (
    <>
      <ToastContainer />
      <Paper elevation={6} sx={{ p: 4, borderRadius: 3, maxWidth: 600, mx: 'auto', mt: 4 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom align="center">
          Renew Your Subscription
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center" mt={2}>
            <CircularProgress />
          </Box>
        ) : errorMsg ? (
          <Alert severity="error" sx={{ mt: 2 }}>
            {errorMsg}
          </Alert>
        ) : (
          <Box component="form" noValidate onSubmit={handleSubmit}>
            <TextField
              fullWidth
              required
              type="email"
              label="Email"
              variant="outlined"
              margin="normal"
              value={email}
              disabled
            />

            <TextField
              fullWidth
              type="number"
              label="Number of Vessels"
              variant="outlined"
              margin="normal"
              inputProps={{ min: 1 }}
              value={vesselCount}
              onChange={(e) => setVesselCount(Number(e.target.value))}
              disabled
            />

            <TextField
              select
              fullWidth
              label="Billing Cycle"
              value={billingCycle}
              onChange={(e) => setBillingCycle(e.target.value)}
              margin="normal"
            >
              <MenuItem value="monthly">Monthly</MenuItem>
              <MenuItem value="yearly">Yearly</MenuItem>
            </TextField>

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ mt: 2 }}
              disabled={submitting}
            >
              {submitting ? 'Renewing...' : 'Renew Subscription'}
            </Button>
          </Box>
        )}
      </Paper>
    </>
  );
};

export default RenewSubscription;
